import {Component, input} from '@angular/core';

@Component({
  selector: 'app-storyblok-base',
  template: '<p>Not intended</p>',
  standalone: true
})
export class StoryblokBaseComponent {

  readonly _uid = input<string>();
  readonly component = input<any>();
  readonly name = input<any>();

  /**
   * @deprecated
   */
  readonly nodequeueId = input<string>();

  /**
   * @deprecated
   */
  readonly Name = input<string>();

  /**
   * @deprecated
   */
  readonly col = input<any>();

  /**
   * @deprecated
   */
  readonly nodequeueMax = input<string>();

  /**
   * @deprecated
   */
  readonly generalStyling = input<string>();

  /**
   * @deprecated
   */
  readonly filter_taxonomy = input<string>();

  /**
   * @deprecated
   */
  readonly marginTop = input<string>();
  /**
   * @deprecated
   */
  readonly marginBottom = input<string>();
}
